import { render, staticRenderFns } from "./CardTarjaEnqueteSelecaoSportv.vue?vue&type=template&id=1ac42454&scoped=true"
import script from "./CardTarjaEnqueteSelecaoSportv.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteSelecaoSportv.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteSelecaoSportv.vue?vue&type=style&index=0&id=1ac42454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac42454",
  null
  
)

export default component.exports